import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './style.css';

const Circle = ({ className, width, angle, blur, distance, theme }) => {
  const customClassName = classNames('circle', `-${theme}`, className);

  const radians = (angle * Math.PI) / 180;
  const x = Math.cos(radians) * distance;
  const y = Math.sin(radians) * distance;
  const shadowColor =
    theme === 'blue' ? '#1833625e' : 'rgba(155, 180, 206, 0.18)';

  const style = {
    width,
    paddingTop: width,
    boxShadow: `${x}px ${y}px ${blur}px ${shadowColor}`,
    background: 'transparent',
  };
  return <div className={customClassName} alt="circ" style={style} />;
};

Circle.propTypes = {
  width: PropTypes.string,
  theme: PropTypes.oneOf(['blue', 'white']),
  className: PropTypes.string,
  angle: PropTypes.number,
  blur: PropTypes.number,
  distance: PropTypes.number,
};

Circle.defaultProps = {
  theme: 'blue',
  className: null,
  width: '100%',
  angle: 0,
  blur: 32,
  distance: 8,
};

export default Circle;
